if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          urlInput: this.querySelector('input'),
          shareSummary: this.querySelector('summary'),
          details: this.querySelector('details'),
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        this.querySelector('.share-button__copy')?.addEventListener('click', () => {
          this.copyToClipboard();
        });

        // Instagram button - copy URL to clipboard and open Instagram
        this.querySelector('.share-button__instagram')?.addEventListener('click', async (e) => {
          e.preventDefault();
          const instagramLink = e.currentTarget;
          const urlToCopy = instagramLink.dataset.shareUrl || this.urlToShare;
          
          // Copy URL to clipboard
          let copySuccess = false;
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              await navigator.clipboard.writeText(urlToCopy);
              copySuccess = true;
            } else {
              // Fallback for older browsers
              const textArea = document.createElement('textarea');
              textArea.value = urlToCopy;
              textArea.style.position = 'fixed';
              textArea.style.opacity = '0';
              document.body.appendChild(textArea);
              textArea.select();
              copySuccess = document.execCommand('copy');
              document.body.removeChild(textArea);
            }
          } catch (err) {
            copySuccess = false;
          }
          
          // Handle copy result
          if (copySuccess) {
            // Show alert first
            alert('Link copied. Paste it using the Link sticker in Instagram Story.');
            // Open Instagram website in new tab after alert is dismissed
            // Store the open function reference to maintain user action context
            const openInstagram = () => {
              window.open('https://www.instagram.com/', '_blank', 'noopener');
            };
            // Use setTimeout with 0 delay to execute after alert is dismissed
            setTimeout(openInstagram, 0);
          } else {
            alert('Failed to copy link. Please try again.');
          }
        });

        // Close button
        this.querySelector('.share-button__close')?.addEventListener('click', () => {
          this.closeShareButton();
        });
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value);
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
      }

      closeShareButton() {
        if (this.elements.details) {
          this.elements.details.removeAttribute('open');
          this.elements.shareSummary.setAttribute('aria-expanded', 'false');
        }
      }
    }
  );
}
